import watchBlockedCompaniesSaga from './blockedCompanies'
import watchEducationsSaga from './educations'
import watchEmploymentSaga from './employmentPreferences'
import watchOnlineProfileSaga from './onlineProfiles'
import watchProfileSaga from './profile'
import watchProfileCompletionSaga from './profileCompletion'
import watchProjectsSaga from './projects'
import watchRolesSaga from './desiredRoles'
import watchTopSkillsSaga from './topSkills'
import watchUploadedFilesSaga from './uploadedFiles'
import watchWorkHistorySaga from './workHistory'

// Import services sagas

import watchRoleListSaga from './roleList'
import watchStatusInfoSaga from './statusInfo'

export default () => [
  watchBlockedCompaniesSaga(),
  watchEducationsSaga(),
  watchEmploymentSaga(),
  watchOnlineProfileSaga(),
  watchProfileSaga(),
  watchProfileCompletionSaga(),
  watchProjectsSaga(),
  watchRolesSaga(),
  watchTopSkillsSaga(),
  watchUploadedFilesSaga(),
  watchWorkHistorySaga(),
  watchRoleListSaga(),
  watchStatusInfoSaga(),
]
